
/**
 * Utility functions for detecting cookie support and availability
 */

/**
 * Checks if cookies are enabled in the browser
 * This implementation avoids eval and uses multiple detection methods
 */
export const areCookiesEnabled = (): boolean => {
  // Try multiple methods to detect if cookies are enabled
  try {
    // Method 1: Try setting and reading a test cookie
    const testCookie = 'cookietest=' + Date.now();
    document.cookie = testCookie + '; SameSite=Lax';
    const cookieEnabled = document.cookie.indexOf(testCookie) !== -1;
    
    // Clean up test cookie
    document.cookie = testCookie + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=Lax';
    
    // Method 2: Check navigator.cookieEnabled as fallback
    if (!cookieEnabled && navigator && 'cookieEnabled' in navigator) {
      return navigator.cookieEnabled;
    }
    
    // Method 3: Try localStorage as a last resort
    if (!cookieEnabled) {
      try {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
        // If localStorage works but cookies don't, cookies might be specifically blocked
        console.log('localStorage works but cookies might be blocked');
        return false;
      } catch (e) {
        console.log('Both localStorage and cookies are blocked');
        return false;
      }
    }
    
    return cookieEnabled;
  } catch (e) {
    // If any error occurs, assume cookies are disabled
    console.error('Error checking cookie status:', e);
    return false;
  }
};

/**
 * Checks if we have user consent to use cookies
 */
export const hasCookieConsent = (): boolean => {
  try {
    return localStorage.getItem('cookie-consent') === 'true';
  } catch (e) {
    return false;
  }
};
